let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gpKR3")).then(() => parcelRequire('4iWHF'));